export const TOOLS = {
  EMBEDDED_IMAGE: 'embeddedImage',
  EMBEDDED_VIDEO: 'embeddedVideo',
  EMOJI: 'emoji',
  MENTION_USER: 'mentionUser',
};
